import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectDetailsTab } from "../../../redux/selector";
import { DetailField } from "../../../types";
import { useStyles } from "./styles";

const renderField = (
  field: DetailField,
  styles: ReturnType<typeof useStyles>,
  t: (key: string) => string
) => (
  <Box key={field.id} className={styles.field}>
    <Typography className={styles.label}>{t(field.labelKey)}</Typography>
    <Box
      component="div"
      className={
        field.variant === "success" ? styles.valueSuccess : styles.value
      }
    >
      {field.valueKey ? t(field.valueKey) : field.value}
    </Box>
  </Box>
);

const DetailsTab = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const sections = useSelector(selectDetailsTab);

  if (!sections || sections.length < 2) {
    return null;
  }

  const [generalSection, datesSection] = sections;

  return (
    <Box className={styles.content}>
      <Box className={styles.section}>
        <Typography className={styles.sectionTitle}>
          {t(generalSection.titleKey)}
        </Typography>
        <Box
          className={styles.fieldGrid}
          style={{
            gridTemplateColumns: `repeat(${generalSection.columns}, minmax(0, 1fr))`,
          }}
        >
          {generalSection.fields.map((field) =>
            renderField(field, styles, t)
          )}
        </Box>
      </Box>

      <Box className={styles.divider} />

      <Box className={styles.section}>
        <Typography className={styles.sectionTitle}>
          {t(datesSection.titleKey)}
        </Typography>
        <Box className={styles.datesRow}>
          {datesSection.fields.map((field) => renderField(field, styles, t))}
          <Button variant="contained" className={styles.saveButton}>
            {t("VECHILE_STATUS.DETAIL.SAVE_DATES")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DetailsTab;
